module.exports = __webpack_public_path__ + "img/@logo_sswells.9d960dd1.png";